import React, { useState, useEffect } from 'react';
import {
  Flex,
  Box,
  Text,
  useColorModeValue,
  HStack
} from '@chakra-ui/react'
import Question from './Question';
import ReplaceButton from './ReplaceButton';

const MobileQuestion = ({ quizData, updateSelection, quizOver, replaceQuestion, swapUsed, setAllQSeen }) => {
  const arrowStyles = {
    cursor: "pointer",
    pos: "absolute",
    top: "50%",
    w: "auto",
    mt: "-22px",
    p: "16px",
    color: useColorModeValue('black','white'),
    fontWeight: "bold",
    fontSize: "18px",
    transition: "0.6s ease",
    borderRadius: "0 3px 3px 0",
    userSelect: "none",
    
  };

  const selectedSlideColor = useColorModeValue("blackAlpha.800","whiteAlpha.800");
  const inertSlideColor = useColorModeValue("blackAlpha.500","whiteAlpha.500")

  const slides = quizData;

  const [currentSlide, setCurrentSlide] = useState(0);

  const slidesCount = 5;

  useEffect(() => {
    if(currentSlide === (slidesCount-1)){
      setAllQSeen(true);
    }
  }, [currentSlide,setAllQSeen]);

  const prevSlide = () => {
    setCurrentSlide((s) => (s === 0 ? slidesCount - 1 : s - 1));
  };
  const nextSlide = () => {
    setCurrentSlide((s) => (s === slidesCount - 1 ? 0 : s + 1));
  };
  const setSlide = (slide) => {
    setCurrentSlide(slide);
  };
  const carouselStyle = {
    transition: "all .5s",
    ml: `-${currentSlide * 100}%`,
  };

  return (
    <Flex
      className='carousel'
      w="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Flex w='100%' overflow="hidden" pos="relative">
        <Flex  w="100%" {...carouselStyle}>
          {slides.map((question, sid) => (
            <Box key={`slide-${sid}`} boxSize="full" shadow="md" flex="none">
              {!swapUsed && !quizOver && <ReplaceButton key={sid} replaceQuestion={()=>replaceQuestion(question.id)}/>}
            <Question
              key={question.id} 
              question={question} 
              updateSelection={updateSelection} 
              quizOver={quizOver}
              />
            </Box>

          ))}
        </Flex>
        <Text {...arrowStyles} left="0" onClick={prevSlide}>
          &#10094;
        </Text>
        <Text {...arrowStyles} right="0" onClick={nextSlide}>
          &#10095;
        </Text>
        <HStack justify="center" pos="absolute" bottom="8px" w="full">
          {Array.from({ length: slidesCount }).map((_, slide) => (
            <Box
              key={`dots-${slide}`}
              cursor="pointer"
              boxSize={["7px", "7px ", "15px"]}
              m="0 2px"
              bg={currentSlide === slide ? selectedSlideColor : inertSlideColor}
              rounded="50%"
              display="inline-block"
              transition="background-color 0.6s ease"
              _hover={{ bg: "blackAlpha.800" }}
              onClick={() => setSlide(slide)}
            ></Box>
          ))}
        </HStack>
      </Flex>
    </Flex>
  );
}

export default MobileQuestion;